import gsap from 'gsap';

const INTRO_VIDEO =
  'https://storage.cloud.google.com/cilex-musical-paint-video-backgrounds/intro.mp4';
const INTRO_COVER = require('url:../src/assets/atmosphere/intro_bg.jpg');
const INTRO_COLOR = '#9783c8';

class Background {
  constructor(isMobile = false) {
    this.isMobile = isMobile;
    this.mainContainer = document.getElementById('bg-container');
    this.imagesContainer = document.createElement('div');
    this.video = null;
    this.bgImages = [];
    this.currentImageUrl = '';
    this.handlers = {
      videoPause: this.onVideoStopped.bind(this),
      videoPlaying: this.onVideoPlaying.bind(this),
    };
    this.imagesContainer.classList.add('images-container');
    this.mainContainer.appendChild(this.imagesContainer);
    if (!this.isMobile) {
      this.video = document.createElement('video');
      this.video.id = 'bgvid';
      this.video.controls = false;
      this.video.autoplay = true;
      this.video.muted = true;
      this.video.loop = true;
      this.video.playsinline = true;
      this.video.style.opacity = 0;
      this.mainContainer.appendChild(this.video);
      this.video.addEventListener('play', this.handlers.videoPlaying);
      this.video.addEventListener('playing', this.handlers.videoPlaying);
      this.video.addEventListener('pause', this.handlers.videoPause);
      //this.video.addEventListener('waiting', this.handlers.videoPause);
      //this.video.addEventListener('suspend', this.handlers.videoPause);
      this.video.addEventListener('emptied', this.handlers.videoPause);
    }
    this.setBackground(INTRO_COVER, null, INTRO_COLOR);
  }

  onVideoPlaying(e) {
    gsap.to(this.video, { duration: 0.6, opacity: 1, delay: 0.06 });
  }

  onVideoStopped(e) {
    gsap.killTweensOf(this.video);
    this.video.style.opacity = 0;
  }

  loadIntroVideo() {
    this.setBackground(INTRO_COVER, INTRO_VIDEO, INTRO_COLOR);
  }

  setBackground(imageUrl, videoUrl = null, color) {
    this.mainContainer.style.backgroundColor = color;
    this.addImage(imageUrl);
    if (this.video && videoUrl && videoUrl.length) {
      gsap.killTweensOf(this.video);
      this.video.style.opacity = 0;
      this.video.src = videoUrl;
    } else if (this.video) {
      gsap.killTweensOf(this.video);
      this.video.style.opacity = 0;
      this.video.src = '';
    }
  }

  checkImages() {
    for (let i = this.bgImages.length - 1; i >= 0; i--) {
      if (this.bgImages[i].url !== this.currentImageUrl) {
        gsap.killTweensOf(this.bgImages[i]);
        this.imagesContainer.removeChild(this.bgImages[i]);
        this.bgImages.splice(i, 1);
      }
    }
  }

  showImage() {
    for (const image of this.bgImages) {
      if (image.loaded && image.url == this.currentImageUrl) {
        gsap.to(image, {
          duration: 0.5,
          opacity: 1,
          delay: 0.05,
          onComplete: this.checkImages,
          callbackScope: this,
        });
        break;
      }
    }
  }

  addImage(url) {
    const image = new Image();
    image.style.opacity = 0;
    image.loaded = false;
    image.url = url;
    image.onload = () => {
      image.loaded = true;
      this.showImage();
    };
    this.bgImages.push(image);
    this.imagesContainer.appendChild(image);
    this.currentImageUrl = url;
    image.src = url;
  }

  changeAtmosphere(atmosphereData) {
    this.setBackground(
      atmosphereData.bg,
      atmosphereData.videoUrl,
      atmosphereData.averageBackgroundColor
    );
  }
}

export { Background };
